import ModalPauseError from './ModalPauseError'

export default ModalPauseError
// eslint-disable-next-line import/export
export * from './ModalPauseError'
